import { render, staticRenderFns } from "./TableCSV.vue?vue&type=template&id=975d7824&scoped=true&"
import script from "./TableCSV.vue?vue&type=script&lang=js&"
export * from "./TableCSV.vue?vue&type=script&lang=js&"
import style0 from "./TableCSV.vue?vue&type=style&index=0&id=975d7824&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975d7824",
  null
  
)

export default component.exports